import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

const MOBILE_NAV_HEADER_HEIGHT = 55;

export const StyledMobileHeaderNavContainer = styled.div<{ isMobileMenuExpanded: boolean }>`
  position: ${({ isMobileMenuExpanded }) => (isMobileMenuExpanded ? 'fixed' : 'relative')};

  display: flex;
  flex-direction: column;

  background-color: white;

  width: 100%;
  height: 100%;

  z-index: 1000;
`;

export const StyledMenuIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
`;

export const StyledMobileHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  height: ${MOBILE_NAV_HEADER_HEIGHT}px;

  padding: ${spaceMixin('sm')};
`;

export const StyledLinkListContainer = styled.div`
  flex-direction: column;

  padding-top: 20px;
  width: 100%;
  height: calc(100% - 50px);
  height: 100%;
  overflow: scroll;
  z-index: 1000;
`;

export const StyledLogoContainer = styled.div<{ altLogo?: boolean }>`
  display: flex;
  align-items: center;

  width: ${({ altLogo = true }) => (altLogo ? '136px' : '120px')};
`;
